import { render } from "./ProcenaKandidataComponent.vue?vue&type=template&id=c4672adc&scoped=true&lang=html"
import script from "./ProcenaKandidataComponent.vue?vue&type=script&lang=js"
export * from "./ProcenaKandidataComponent.vue?vue&type=script&lang=js"

import "./ProcenaKandidataComponent.vue?vue&type=style&index=0&id=c4672adc&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-c4672adc"

export default script